// extracted by mini-css-extract-plugin
var _1 = "GTsz6";
export { _1 as "base" }
